import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {translateProps} from '../../../lib/react/higher-order-components';
import {AppMode} from '../../../app/app-types';
import OEIcon from '../../elements/oe-icon';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OETargetMenu from '../../elements/target-menu/oe-target-menu';
import {OERightTopBarEntryTypes, OERightTopBarPropTypes, OERightTopBarConfigFactory} from './oe-right-top-bar-model';

// OERightTopBarEntryFactory
export class OERightTopBarEntryFactory extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.onFullscreenBtnPressed = this.onFullscreenBtnPressed.bind(this);
        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    render()    {
        if(!this.props.config.enabled)  return null;

        let key = 0;
        let elements = [];
        
        this.props.config.entries.forEach(entry => {
            if(entry.type === OERightTopBarEntryTypes.targetMenu) {
                elements.push(<OETargetMenu key={key++} moduleId={this.props.moduleId} hideWhenMediaCenterOpen={true} subOrientation={OETargetMenu.subOrientation.left}/>);
            }
        });

        if(this.props.showFullscreenBtn)    {
            elements.push(
                <div key={key++} className="main-menu-control-button right-top-bar-button view-port-label-text-color-border">
                    <a onClick={this.onFullscreenBtnPressed}>
                        <OEIcon code={this.props.isFullscreen ? OEIconCodes.compress : OEIconCodes.expand} />
                    </a>
                </div>
            );
        }

        if(this.props.showCloseBtn)    {
            elements.push(
                <div key={key++} className="main-menu-control-button right-top-bar-button view-port-label-text-color-border">
                    <a onClick={this.onCloseBtnPressed}>
                        <OEIcon code={OEIconCodes.close} />
                    </a>
                </div>
            );
        }

        return (
            <React.Fragment>
                {elements}
            </React.Fragment>
        );
    }

    onFullscreenBtnPressed()    {
        if(this.props.onFullscreenBtnPressed)    {
            this.props.onFullscreenBtnPressed();
            return;
        }
        if(this.props.appComponent && this.props.appComponent.appStateController)  this.props.appComponent.appStateController.setFullscreen(!this.props.isFullscreen);
    }

    onCloseBtnPressed() {
        if(this.props.onCloseBtnPressed)    {
            this.props.onCloseBtnPressed();
            return;
        }
        if(this.props.appComponent && this.props.appComponent.app)  this.props.appComponent.app.changeMode(AppMode.start);
    }
}

OERightTopBarEntryFactory.defaultProps = {
    moduleId: '',
    config: OERightTopBarConfigFactory.buildStdConfig(),
    showFullscreenBtn: true,
    isFullscreen: false,
    showCloseBtn: false
};

OERightTopBarEntryFactory.propTypes = {
    moduleId: PropTypes.string,
    appComponent: PropTypes.object,
    config: OERightTopBarPropTypes.config,
    showFullscreenBtn: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    showCloseBtn: PropTypes.bool,
    onFullscreenBtnPressed: PropTypes.func,
    onCloseBtnPressed: PropTypes.func,
};

export const OERightTopBarEntryFactoryConnected = connectAppEnv((env) => { 
    return {
        appComponent: env.component,
        showFullscreenBtn: env.state.showFullscreenBtn,
        isFullscreen: env.state.isFullscreen,
        showCloseBtn: env.config.isLicensingStart,
    };
})(translateProps(props => {
    if(props.config)    props.showFullscreenBtn = props.showFullscreenBtn && !!props.config.fullscreenBtn;
    return props;
})(OERightTopBarEntryFactory));

// OERightTopBar
export class OERightTopBar extends React.PureComponent {
    render() {
        if(!this.props.config.enabled)  return null;
        return (
            <div className="right-top-bar" style={this.props.style}>
                <OERightTopBarEntryFactoryConnected {...this.props}/>
            </div>
        );
    }
}

OERightTopBar.defaultProps = {
    moduleId: '',
    config: OERightTopBarConfigFactory.buildStdConfig()
};

OERightTopBar.propTypes = {
    moduleId: PropTypes.string,
    config: OERightTopBarPropTypes.config,
    onFullscreenBtnPressed: PropTypes.func,
    onCloseBtnPressed: PropTypes.func,
};

export default connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    return {
        appComponent: env.component,
        config: ui.rightTopBar,
        version: env.config.version,
        target: env.config.target
    }
})(OERightTopBar);